import {
  START_CHECKOUT,
  START_CHECKOUT_SUCCESS,
  START_CHECKOUT_ERROR,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_ERROR,
  REACTIVATE_SUBSCRIPTION,
  REACTIVATE_SUBSCRIPTION_SUCCESS,
  REACTIVATE_SUBSCRIPTION_ERROR,
} from './constants';

export function startCheckout(userId, priceId, returnTo, planType, program) {
  return {
    type: START_CHECKOUT,
    userId,
    priceId,
    returnTo,
    planType,
    program,
  };
}

export function startCheckoutSuccess(checkoutUrl) {
  return {
    type: START_CHECKOUT_SUCCESS,
    checkoutUrl,
  };
}

export function startCheckoutError(error) {
  return {
    type: START_CHECKOUT_ERROR,
    error,
  };
}

export function cancelSubscription(userId) {
  return {
    type: CANCEL_SUBSCRIPTION,
    userId,
  };
}

export function cancelSubscriptionSuccess(successMessage) {
  return {
    type: CANCEL_SUBSCRIPTION_SUCCESS,
    successMessage,
  };
}

export function cancelSubscriptionError(error) {
  return {
    type: CANCEL_SUBSCRIPTION_ERROR,
    error,
  };
}

export function reactivateSubscription(userId) {
  return {
    type: REACTIVATE_SUBSCRIPTION,
    userId,
  };
}

export function reactivateSubscriptionSuccess(successMessage) {
  return {
    type: REACTIVATE_SUBSCRIPTION_SUCCESS,
    successMessage,
  };
}

export function reactivateSubscriptionError(error) {
  return {
    type: REACTIVATE_SUBSCRIPTION_ERROR,
    error,
  };
}
